import { uniqueArray } from '@SonarCX/utilities'
import { get, set } from 'idb-keyval'
import Signal from '../signal'

export const KEY = 'recentUsers'

const MAX_RECENT_USERS = 5

type Args = {
  envName: string
  // True or false for external/internal, or a string for a specific user type
  userType: boolean | string
  items: string | string[]
  userID: string
}

const getKey = ({ envName, userType }: Pick<Args, 'envName' | 'userType'>) =>
  `${KEY}__${envName}__${userType}`

const getItems = async ({
  envName,
  userType
}: Pick<Args, 'envName' | 'userType'>) => {
  const key = getKey({ envName, userType })
  const items: string[] = (await get(key)) ?? []
  return items
}

const setItems = async ({
  envName,
  userType,
  items
}: Pick<Args, 'envName' | 'userType' | 'items'>) => {
  const key = getKey({ envName, userType })
  await set(key, items)
}

export const addRecentUser = async ({
  envName,
  userType,
  userID
}: Pick<Args, 'envName' | 'userType' | 'userID'>) => {
  const items = await getItems({ envName, userType })

  // Keep only the last MAX_RECENT_USERS unique users
  const updated = uniqueArray(
    typeof userID === 'string' ? [userID] : userID,
    items
  ).slice(0, MAX_RECENT_USERS)

  await setItems({ envName, userType, items: updated })

  window.SONAR_SIGNAL.signal(Signal.recentUsers)
}

export const getRecentUsers = async ({
  envName,
  userType
}: Pick<Args, 'envName' | 'userType'>) => {
  return await getItems({ envName, userType })
}
